import { AjaxGetAndReplaceHtml, AjaxGetAndReplaceHtmlAndOuterElement } from "../../shared/ajaxGetAndReplaceHtml";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { UrlEnums } from "../../shared/utilities/enums/urlEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ISinglePagingSelectableCarousel } from "../selectableCarousel/singlePagingSelectableCarousel";
import { ICarouselGallery } from "./carouselGallery";
import { IPopOutCarouselGallery, PopOutCarouselGallery } from "./popOutCarouselGallery";
const urlPaths = require('../../config/urlPaths.json');
export interface IAjaxPopOutCarouselGallery extends IPopOutCarouselGallery {
    updateCarouselCurrentSelectedIndex:(index: number) => void;
    singlePagingSelectableCarousel: ISinglePagingSelectableCarousel;
}

export class AjaxPopOutCarouselGallery extends PopOutCarouselGallery implements IPopOutCarouselGallery {

    constructor(public htmlElement: Element, carouselCurrentSelectedIndex?: number, topLevelHtmlElement?: HTMLElement) {
        super(htmlElement, topLevelHtmlElement);
        if (carouselCurrentSelectedIndex !== undefined) {

            this.updateCarouselCurrentSelectedIndex(carouselCurrentSelectedIndex);
        }
    }

    updateCarouselCurrentSelectedIndex(index: number) {
        super.updateCarouselCurrentSelectedIndex(index);
        if (this.pagingSelectableCarousel.carouselCurrentSelectedIndex !== index) {
            this.pagingSelectableCarousel.updateCarouselCurrentSelectedIndex(index);
        }
        if (this.singlePagingSelectableCarousel.carouselCurrentSelectedIndex !== index) {
            this.singlePagingSelectableCarousel.updateCarouselCurrentSelectedIndex(index);
        }
    }

    static async getPopOutCarouselHtml(placeholderHtmlElement: HTMLElement): Promise<void> {
        let productUrl: string = document.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Product.ProductUrl))
            .getAttribute(AttributeEnums.Product.ProductUrl);
        let lineIdSectionIndex: number = productUrl.lastIndexOf('/');
        let splitString: string[] = (productUrl.substring(lineIdSectionIndex + 1).split('-'));
        let lineId: number = +splitString[0];
        await AjaxGetAndReplaceHtmlAndOuterElement(placeholderHtmlElement, `${urlPaths.websiteUrl}${UrlEnums.PartialUrls.ProductGalleryPopOut}/${lineId}`);
    }


    dispose(): void {

        super.dispose();
    }
}